window.addEventListener('DOMContentLoaded', function(event) {
  var dhEvent = window.dhEvent;
  dhEvent.checkCheckboxIsChecked();
  dhEvent.listenerCheckbox();
});